// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-arrow{color:#443fdb}.link-arrow__icon{font-size:.625rem;padding-left:.5rem}.link-arrow:active,.link-arrow:focus,.link-arrow:hover{text-decoration:none}.link-arrow:active span,.link-arrow:focus span,.link-arrow:hover span{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
